export const memberSearchFieldOptions = [
  { id: 'name', name: 'Nome' },
  { id: 'registration', name: 'Matrícula' },
];
